import {
  ConversationModel,
  getConversationLastModified,
  getConversationOtherPartyToken,
  getConversationOtherPartyBrandToken,
  getConversationIdentifier,
} from "./ConversationModel";

export const conversationLastModifiedComparator = (
  conversationA: ConversationModel,
  conversationB: ConversationModel
) => {
  const lastModifiedA = getConversationLastModified(conversationA);
  const lastModifiedB = getConversationLastModified(conversationB);
  if (lastModifiedA === undefined) {
    return 1;
  }
  if (lastModifiedB === undefined) {
    return -1;
  }
  if (lastModifiedA < lastModifiedB) {
    return 1;
  }
  if (lastModifiedA > lastModifiedB) {
    return -1;
  }
  // Use the conversation token to break ties to ensure a stable sort
  const identifierA = getConversationIdentifier(conversationA) ?? "";
  const identifierB = getConversationIdentifier(conversationB) ?? "";
  if (identifierA === identifierB) {
    return 0;
  }
  return identifierA < identifierB ? 1 : -1;
};

export const conversationRetailerContextComparator = (
  conversationA: ConversationModel,
  conversationB: ConversationModel,
  retailerContextToken: string | undefined
) => {
  if (retailerContextToken === undefined) {
    return 0;
  }
  if (getConversationOtherPartyToken(conversationA) === retailerContextToken) {
    return -1;
  }
  if (getConversationOtherPartyToken(conversationB) === retailerContextToken) {
    return 1;
  }
  return 0;
};

export const conversationBrandContextComparator = (
  conversationA: ConversationModel,
  conversationB: ConversationModel,
  brandContextToken: string | undefined
) => {
  if (brandContextToken === undefined) {
    return 0;
  }
  if (
    getConversationOtherPartyBrandToken(conversationA) === brandContextToken
  ) {
    return -1;
  }
  if (
    getConversationOtherPartyBrandToken(conversationB) === brandContextToken
  ) {
    return 1;
  }
  return 0;
};
